import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-codepen",
  "use": "icon-codepen-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-codepen\" id=\"icon-codepen\"><polygon points=\"12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2\" /><line x1=\"12\" y1=\"22\" x2=\"12\" y2=\"15.5\" /><polyline points=\"22 8.5 12 15.5 2 8.5\" /><polyline points=\"2 15.5 12 8.5 22 15.5\" /><line x1=\"12\" y1=\"2\" x2=\"12\" y2=\"8.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol